import { render, staticRenderFns } from "./dish.vue?vue&type=template&id=47263a33&scoped=true"
import script from "./dish.vue?vue&type=script&lang=js"
export * from "./dish.vue?vue&type=script&lang=js"
import style0 from "./dish.vue?vue&type=style&index=0&id=47263a33&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47263a33",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47263a33')) {
      api.createRecord('47263a33', component.options)
    } else {
      api.reload('47263a33', component.options)
    }
    module.hot.accept("./dish.vue?vue&type=template&id=47263a33&scoped=true", function () {
      api.rerender('47263a33', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/supplySystem/commodityManagement/dishesManagement/dish.vue"
export default component.exports